import httpClient from 'hub-http/clients/apiClient';
export const fetchBannerInfo = (scope, sourceURL) => httpClient.get(`/vetting/public/v1/user-verification/bannerinfo/scope/${scope}?sourceURL=${sourceURL}`);